"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iWorksiteDiaryStats = exports._iWorksiteDiaryStats = void 0;
const t = require("io-ts");
exports._iWorksiteDiaryStats = t.interface({
    diary_uuid: t.string,
    entries_in_total: t.number,
    signed: t.number,
    waiting_for_masters_signature: t.number,
    waiting_for_supervisors_signature: t.number,
    started_jobs: t.number,
    ongoing_jobs: t.number,
    completed_jobs: t.number,
    discontinued_jobs: t.number
});
exports.iWorksiteDiaryStats = t.clean(exports._iWorksiteDiaryStats);
//# sourceMappingURL=worksiteDiaryStats.js.map